import noUiSlider from 'nouislider'

export default class RangeSlider {
    #element
    #target

    constructor(element) {
        this.#element = element
        this.#target = document.querySelector(element.dataset.gpTarget)

        let min = parseInt(element.dataset.gpMin ?? element.getAttribute('min'))
        let max = parseInt(element.dataset.gpMax ?? element.getAttribute('max'))
        let step = parseInt(element.dataset.gpStep ?? element.getAttribute('step') ?? 1)
        let current = element.dataset.gpCurrent ? parseInt(element.dataset.gpCurrent) : null

        let config = {
            range: {
                min: min,
                max: max,
            },
            step: step,
            start: [current ?? element.value ?? Math.ceil(max / 2)],
        }

        if (element.dataset.gpPips) {
            config.pips = {
                mode: 'count',
                density: (100 / max) * step,
                values: max,
            }
        }

        if (current) {
            this.#target.value = current
            this.handleSliderStart()
        }

        const slider = noUiSlider.create(element, config)

        slider.on('start', this.handleSliderStart)
        slider.on('end', this.handleSliderChanged)
    }

    static initAll(selector) {
        Array.from(document.querySelectorAll(selector), (element) => new RangeSlider(element))
    }

    handleSliderStart = () => {
        this.#element.classList.add('gp-slider-active')
    }

    handleSliderChanged = () => {
        this.#target.value = parseInt(this.#element.noUiSlider.get())
    }
}
